import {ServiceBase} from "../ServiceBase";
import {ILoginPopupData, ILoginPopupService} from "./login-popup.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

const loginPopupAcknowledgeStorageKey = 'orbit_login_popup_acknowledge';

export class LoginPopupService extends ServiceBase implements ILoginPopupService{
    private _loginPopupShown = false;
    private _loginPopupPreviousCallPromise = null;

    constructor(services: IServiceFactoryExtended) {
        super(services);

        if(this.services.regulation.isLoginPopupEnabled()) {
            this._subscribe();

            // We need this for users that refresh the page while not approve yet the login popup.mo
            this.showLoginGamePopup();
        }
    }

    private _subscribe() {
        this.services.sdk.events.onOAuthStateChanged((params) => {
            this._loginPopupShown = false;
            this.services.localStorage.setItem(loginPopupAcknowledgeStorageKey, false);

            if(this.services.user.isAuthorized) {
                this.showLoginGamePopup(params?.fromRegistration);
            }
        });
    }

    private _onAcknowledge(resolve) {
        this.services.localStorage.setItem(loginPopupAcknowledgeStorageKey, true);
        this._loginPopupPreviousCallPromise = null;
        this._loginPopupShown = false;
        resolve();
    }

    public showLoginGamePopup(fromRegistration?: boolean): Promise<void> {
        let currentPromise =  new Promise<void>((resolve)=> {
            // Not show login popup if already shown - for example open game and login show it and then login popup game step try to show it
            if(this._loginPopupShown) {
                return this._loginPopupPreviousCallPromise.then(() => resolve());
            }

            if(this._skipPopupConditions(fromRegistration)) {
                    resolve();
                    return;
            }

            this._loginPopupShown = true;
            return this.services.specificDialogs.showLoginPopup(()=> this._onAcknowledge(resolve));
        });

        this._loginPopupPreviousCallPromise = currentPromise;
        return this._loginPopupPreviousCallPromise;
    }

    public getLoginPopupData(): ILoginPopupData {
        try {
            return JSON.parse(this.services.sdk.extractTokenProperty('regulationMessages'));
        } catch(err) {
            return null;
        }
    }

    private _skipPopupConditions(fromRegistration: boolean) {
        return fromRegistration ||
            this.services.sdk.isLoginFromRegistration ||
            this.services.user.isDocUploadRequired() ||
            !this.services.regulation.isLoginPopupEnabled() ||
            !this.services.user.isAuthorized ||
            this.services.localStorage.getItem(loginPopupAcknowledgeStorageKey) === "true";
    }

}